<template>
    <div>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <ul class="matches">
                            <li style="list-style: none"
                                class="align-items-lg-center align-items-center justify-content-between text-center"
                            >
                                <div>
                                    <h2>Error en la compra</h2>
                                    <p>Ha ocurrido un error durante su proceso de compra, se le redireccionará en unos segundos</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        mounted() {
            setTimeout(() => {
                this.$router.push('/eventos');
            }, 5000);
        }
    }
</script>